import { combineReducers } from '@reduxjs/toolkit';
import auth from './authReducer';
import bookings from './bookingReducer';
import usersAdmin from './usersAdminReducer';
import invites from './invitesReducer';
import roles from './rolesReducer';
import apiKeys from './apiKeysReducer';

export default combineReducers({ auth, bookings, usersAdmin, invites, roles, apiKeys });
